export default __webpack_public_path__ + "static/media/organizza_logo_branco-simples.735f38f6.png";